<script>
/**
 * The footer under every listing table.
 *
 * ── Why a component ─────────────────────────────────────────────────────
 * one_sales inlines this block in ~30 pages, and the copies disagree: most
 * bind `:per-page="perPage"` from local component data while the rows come
 * from the server, so a page whose size came back different from the SPA's
 * default paginated wrongly — the control showed the right number of pages for
 * the wrong page size. Here the page size comes from the SERVER's pagination
 * object, which is the only one that describes the rows actually on screen.
 *
 * ── It is server-side paging ────────────────────────────────────────────
 * The table is handed exactly one page of rows, so `b-pagination` must NOT be
 * given the table as its target — it emits `change` and the page re-fetches.
 * Binding both is how you get a 10-row table paginating itself into pages of
 * one.
 */
export default {
  name: 'ListingPagination',
  props: {
    /**
     * The store's pagination object, as sharedHelper.apiPaginationAdapter
     * shapes it: { pageNumber, pageSize, lastPage, tableRowsCounts, total }.
     */
    pagination: {
      type: Object,
      default: () => ({ pageNumber: 1, pageSize: 10, total: 0, tableRowsCounts: 0 }),
    },
  },
  computed: {
    currentPage() {
      return Number(this.pagination.pageNumber) || 1
    },
    perPage() {
      return Number(this.pagination.pageSize) || 10
    },
    total() {
      return Number(this.pagination.total) || 0
    },
    /** 1-based index of the first row on screen; 0 when there are none. */
    from() {
      return this.total === 0 ? 0 : (this.currentPage - 1) * this.perPage + 1
    },
    to() {
      // `tableRowsCounts` is what the server actually returned, which is
      // shorter than perPage on the last page.
      const count = Number(this.pagination.tableRowsCounts) || 0
      return this.from === 0 ? 0 : this.from + count - 1
    },
  },
  methods: {
    onChange(pageNumber) {
      this.$emit('change', pageNumber)
    },
  },
}
</script>

<template>
  <div class="row align-items-center mt-3">
    <div class="col-sm-12 col-md-5">
      <!-- Said in words because "page 3 of 7" does not answer "did my filter
           do anything", and that is the question somebody has after typing in
           the search box. -->
      <p class="text-muted small mb-0">
        {{ $t('label.showingXtoYofZ', [from, to, total]) }}
      </p>
    </div>
    <div class="col-sm-12 col-md-7">
      <div class="dataTables_paginate paging_simple_numbers float-md-right">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination
            :value="currentPage"
            :total-rows="total"
            :per-page="perPage"
            @change="onChange"
          ></b-pagination>
        </ul>
      </div>
    </div>
  </div>
</template>
